import type { CustomFlowbiteTheme } from 'flowbite-react';

export const toastTheme: CustomFlowbiteTheme['toast'] = {
  root: {
    base: 'flex w-full max-w-xs items-center rounded-lg bg-white p-4 text-titan-night-500 shadow',
    closed: 'opacity-0 ease-out-quart',
  },
  toggle: {
    base: '-m-1.5 ml-auto inline-flex h-8 w-8 rounded-lg bg-white p-1.5 text-titan-night-400 hover:bg-titan-night-100 hover:text-titan-night-900 focus:ring-2 focus:ring-titan-night-300',
    icon: 'h-5 w-5 shrink-0',
  },
};
